// extracted by mini-css-extract-plugin
export var statItem = "_ls-1";
export var statsRow = "_ls-0";